import { Granularity } from 'types/contracts.ts'
import { GranularityDuration } from 'types/date.ts'

/**
 * Volumes, prices & billing periods are all metered against the Belgian wall clock, so every period they are bucketed,
 * stepped & labelled in has to be resolved in this timezone instead of the one of the device
 */
export const BELGIAN_TIMEZONE = 'Europe/Brussels'

/** The length of a single period per granularity, used to step through, floor & label periods */
export const GRANULARITY_DURATION: Record<Granularity, GranularityDuration> = {
  [Granularity.MONTH]: { amount: 1, unit: 'month' },
  [Granularity.DAY]: { amount: 1, unit: 'day' },
  [Granularity.HOUR]: { amount: 1, unit: 'hour' },
  [Granularity.QUARTER_HOUR]: { amount: 15, unit: 'minute' }
}

/** Format of the hours in a period label, e.g. 08:00 - 09:00 */
export const HOUR_LABEL_FORMAT = 'HH:mm'

export const DAY_OF_WEEK = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
} as const
export type DayOfWeek = (typeof DAY_OF_WEEK)[keyof typeof DAY_OF_WEEK]
